























import CheckboxList from './CheckboxList.vue';
import ToggleClassDirective from '@/shared/directives/toggle-class-directive';
import {defineComponent} from "@vue/composition-api";
import {useGetters, useState} from "vuex-composition-helpers";

export default defineComponent({
  name: 'Filters',
  components: {
    CheckboxList
  },
  directives: {
    ToggleClassDirective
  },
  props: {
    extraClass: {type: String}
  },
  methods: {
    selectFilter(filterName: string, filterGroup: string): void {
      this.$store.commit('filter/setActiveFilter', filterName);
      this.$store.commit('filter/setActiveFilterGroup', filterGroup);
    },
    trackFilterContainerClick(event: any, filterGroup: string): void {
      const el = event.currentTarget as HTMLElement;
      const willBeActive = !el.classList.contains("vuw-active");
      const interactionType = willBeActive ? "expand_filter" : "close_filter";

      if (typeof window !== "undefined" && (window as any).dataLayer) {
        const cleanFilterName = this.normalizeFilterName(this.filterGroupTitle(filterGroup));
        (window as any).dataLayer.push({
          event: "search_filter",
          interaction_type: interactionType,
          content_filter: cleanFilterName
        });
      }
    },
    normalizeFilterName(name: string): string {
        // To remove the number of checked content_filter_selection. IE: content_filter (1)
        return name.replace(/\s\(\d+\)$/, '');
    }
  },
  setup: () => {
    const {filterGroups} = useState('filter', ['filterGroups'])
    const {
      filterItemsOfGroup,
      filterGroupTitle,
      filterGroupDisplayNames
    } = useGetters('filter', ['filterItemsOfGroup', 'filterGroupTitle', 'filterGroupDisplayNames'])

    return {
      filterGroups,
      filterItemsOfGroup,
      filterGroupTitle,
      filterGroupDisplayNames
    }
  }
})
